import type { EpisodeStatus, JobStatus } from '../api/types'
import { Badge, type Tone } from './ui'

export const JOB_STATUS: Record<JobStatus, { tone: Tone; label: string }> = {
  ready: { tone: 'neutral', label: 'Queued' },
  leased: { tone: 'accent', label: 'Running' },
  succeeded: { tone: 'ok', label: 'Succeeded' },
  failed: { tone: 'danger', label: 'Failed' },
  cancelled: { tone: 'neutral', label: 'Cancelled' },
}

const EPISODE_STATUS: Record<EpisodeStatus, { tone: Tone; label: string }> = {
  draft: { tone: 'neutral', label: 'Draft' },
  uploading: { tone: 'accent', label: 'Uploading' },
  processing: { tone: 'accent', label: 'Processing' },
  ready: { tone: 'ok', label: 'Ready' },
  failed: { tone: 'danger', label: 'Failed' },
  published: { tone: 'ok', label: 'Published' },
}

export function JobStatusBadge({ status }: { status: JobStatus }) {
  const { tone, label } = JOB_STATUS[status]
  return <Badge tone={tone}>{label}</Badge>
}

export function EpisodeStatusBadge({ status }: { status: EpisodeStatus }) {
  const { tone, label } = EPISODE_STATUS[status]
  return <Badge tone={tone}>{label}</Badge>
}
